import { obtenerConfig, guardarConfig } from './config'

/**
 * Lee el estado de licencia desde config.
 * Retorna: { instaladoEn, licencia }
 * - instaladoEn: ISO string del primer arranque (null si nunca se grabó)
 * - licencia: payload del código activado (null si no hay)
 */
export async function obtenerLicencia() {
  const cfg = await obtenerConfig()
  return {
    instaladoEn: cfg.instaladoEn || null,
    licencia: cfg.licencia || null,
  }
}

/** Graba la fecha de primer arranque si aún no existe. */
export async function registrarInstalacion() {
  const cfg = await obtenerConfig()
  if (!cfg.instaladoEn) {
    await guardarConfig({ instaladoEn: new Date().toISOString() })
  }
}

/** Graba el payload de un código de activación válido. */
export async function guardarLicenciaActivada(payload) {
  await guardarConfig({ licencia: payload })
}
